import { render, staticRenderFns } from "./bright-plans.vue?vue&type=template&id=3ef1ac60&"
import script from "./bright-plans.vue?vue&type=script&lang=js&"
export * from "./bright-plans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports